module.exports = __webpack_public_path__ + "static/media/mekhala_balaji.bfcb23ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/prelogin/public/img/testimonial/mekhala_balaji.png
// module id = 535
// module chunks = 0